/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        NotFound: 'NotFound', // 입력하신 내용과 관련한 센터가 없어요.<br>센터명을 확인하고 다시 검색해주세요.
        Bot1: 'Bot1',// '애터미의 회원이 되려면<br>기존 애터미 회원의 후원이 필요해요.',
        Bot2: 'Bot2',// '회원들이 있는 센터 정보가 궁금하면 아래 버튼을 눌러보세요.',
        SelectLocation: 'SelectLocation', // '찾고자 하는 지역을 선택하세요.',
        FindCenter: 'FindCenter',// '센터 정보 찾기',
        Location: 'Location',// '지역',
        CenterInfoView: 'CenterInfoView',// '센터 정보 보기',
        CenterPlaceholder: 'CenterPlaceholder',// '센터명이나 주소로 검색해보세요.',
        CenterInfo: 'CenterInfo',// '센터정보',
        Tel: 'Tel',
        Address: 'Address',
    },
    tomy:{
        kr: {
            NotFound: '입력하신 내용과 관련한 센터가 없어요.<br>센터명을 확인하고 다시 검색해주세요.',
            Bot1: '회원으로 가입하려면 추천인(후원인)이 필요합니다.<br>추천인(후원인)이 없는 경우 가까운 교육센터 등을 통해 가입하실 수 있도록 도와드리고 있습니다.<br>찾기 어려우실 경우 고객센터 1544-8580 , 채팅상담을 통해 문의 부탁 드립니다.',
            SelectLocation: '지역을 선택해주세요. 해당 지역 내 센터 정보를 안내해드리겠습니다. 센터에 전화해보거나 가까운 곳을 방문하시면 후원인에 대한 도움을 받으실 수 있어요.',
            FindCenter: '센터 정보 찾기',
            Location: '지역',    
            CenterInfoView: '센터 정보 보기',
            CenterPlaceholder: '센터명을 검색해보세요.',
            CenterInfo: '센터정보',     
            Tel: '전화번호',
            Address: '주소',           
        },
        eng: {
            NotFound: 'There is no center related to what you entered.<br>Please check the name of the center and search again.',
            Bot1: 'To become an Atomy person, you must have a sponsor. Sponsors can be introduced at the nearest center. You can search for information about the nearest Atomy Center by clicking the button below.',
            SelectLocation: 'Please select a region We will provide you with information about the centers in your area. Sponsors can help by calling the center or visiting your local area.',
            FindCenter: 'Find center information',
            Location: 'area',    
            CenterInfoView: 'View Center Information',
            CenterPlaceholder: 'Search for the center name or street name',
            CenterInfo: 'Center information',  
            Tel: 'Phone number',
            Address: 'address',
        },
    },
    papa:{
        kr: {            
            NotFound: '입력하신 내용과 관련한 센터가 없어요.<br>센터명을 확인하고 다시 검색해주세요.',
            Bot1: '회원으로 가입하려면 추천인(후원인)이 필요합니다.<br>추천인(후원인)이 없는 경우 가까운 교육센터 등을 통해 가입하실 수 있도록 도와드리고 있습니다.<br>찾기 어려우실 경우 고객센터 1544-8580 , 채팅상담을 통해 문의 부탁 드립니다.',
            SelectLocation: '좋아요. 지역을 선택해주세요. 가까운 애터미 센터에 언제든 전화해보거나 찾아가도 좋습니다. 애터미 센터에서 친절하게 맞이해줄 거예요.',
            FindCenter: '센터 정보 찾기',
            Location: '지역',    
            CenterInfoView: '센터 정보 보기',
            CenterPlaceholder: '센터명을 검색해보세요.',
            CenterInfo: '센터정보',            
            Tel: '전화번호',
            Address: '주소',           
        },
        eng: {
            NotFound: 'There is no center related to what you entered.<br>Please check the name of the center and search again.',
            Bot1: "Oh, are we going to meet again as Atomy man next time^^ To sign up as a member, you need a sponsor.. Let's find a center near you first, shall we?",
            SelectLocation: "Good! Please select a region. You can call or visit the nearest Atomy Center at any time. Atomy Center will warmly welcome you.",
            FindCenter: 'Find center information',
            Location: 'area',    
            CenterInfoView: 'View Center Information',
            CenterPlaceholder: 'Search for the center name or street name',
            CenterInfo: 'Center information', 
            Tel: 'Phone number',
            Address: 'address',                      
        },
    },
};
